import axios from "axios";
import api from "./api";

// Create a raw axios instance without interceptors for the temporary subscription flow
const tempApi = axios.create({
  baseURL: process.env.REACT_APP_API_URL ,
});

export interface SubscriptionPlan {
  id: string;
  planName: string;
  price: number;
  currency: string;
  description?: string;
  durationType: string;
  durationValue: number;
  includedFeatures?: string[];
  planTag?: string;
  isVisible: boolean;
  isActive: boolean;
}

export interface CreatePlanPayload {
  planName: string;
  price: number;
  currency: string;
  description?: string;
  durationType: string;
  durationValue: number;
  includedFeatures?: string[];
  planTag?: string | null;
  isVisible?: boolean;
  isActive?: boolean;
}

export interface UpdatePlanPayload extends Partial<CreatePlanPayload> { }

/** Super Admin: get all plans */
export const getAllPlans = async (): Promise<SubscriptionPlan[]> => {
  const { data } = await api.get("/api/super-admin/subscription/all");
  return data.data ?? data;
};

/** Super Admin: create plan */
export const createPlan = async (payload: CreatePlanPayload) => {
  const { data } = await api.post("/api/super-admin/subscription/create", payload);
  return data;
};

/** Super Admin: update plan */
export const updatePlan = async (id: string, payload: UpdatePlanPayload) => {
  const { data } = await api.put(`/api/super-admin/subscription/update/${id}`, payload);
  return data;
};

/** Super Admin: delete plan */
export const deletePlan = async (id: string) => {
  const { data } = await api.delete(`/api/super-admin/subscription/delete/${id}`);
  return data;
};

/** Super Admin: toggle visible */
export const toggleVisible = async (id: string) => {
  const { data } = await api.patch(`/api/super-admin/subscription/toggle-visible/${id}`);
  return data;
};

/** Hospital: get public plans (no auth) */
export const getPublicPlans = async (): Promise<SubscriptionPlan[]> => {
  const { data } = await api.get("/api/hospital/subscription/public-plans");
  return data.data ?? data;
};

/** Hospital: subscribe (auth required) - sends only subscriptionPlanId in body */
export const subscribe = async (planId: string, token?: string) => {
  console.log("Using temp token:", token);
  const config = token ? { headers: { Authorization: `Bearer ${token}` } } : {};
  return tempApi.post("/api/hospital/subscription/subscribe", {
    subscriptionPlanId: planId,
  }, config);
};
